var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#002240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95399 8L12.7835 4.16531C13.0541 3.89431 13.0541 3.47425 12.7835 3.20325C12.5129 2.93225 12.0934 2.93225 11.8227 3.20325L7.99323 7.03794L4.16373 3.2168C3.8931 2.9458 3.47361 2.9458 3.20298 3.2168C2.93234 3.4878 2.93234 3.90786 3.20298 4.17886L7.03248 8.01355L3.21651 11.8347C2.94587 12.1057 2.94587 12.5257 3.21651 12.7967C3.48714 13.0678 3.90663 13.0678 4.17727 12.7967L8.00677 8.96206L11.8363 12.7967C12.1069 13.0678 12.5264 13.0678 12.797 12.7967C13.0677 12.5257 13.0677 12.1057 12.797 11.8347L8.95399 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a020134e3ad6c59ea4d8a79fc36df818.svg";
export { ForwardRef as ReactComponent };